var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/Business") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/Business",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#BEC0C2",
    points: "11 65 45 65 45 10 11 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fillOpacity: 0.25,
    fill: "#000000",
    points: "11 46.9996 11 64.9996 35 64.9996 35 19.9996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#313036",
    points: "11 30 45 30 45 25 11 25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#313036",
    points: "11 20 45 20 45 15.001 11 15.001"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#313036",
    points: "11 40 45 40 45 35 11 35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#313036",
    points: "11 50 45 50 45 45 11 45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#313036",
    points: "11 60 45 60 45 55 11 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#F2F2F2",
    points: "35 70 68.999 70 68.999 20 35 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,43 L39,37 L45,37 L45,43 L39,43 Z M49,43 L49,37 L55,37 L55,43 L49,43 Z M39,32 L39,26 L45,26 L45,32 L39,32 Z M49,32 L49,26 L55,26 L55,32 L49,32 Z M39,54 L39,48 L45,48 L45,54 L39,54 Z M49,54 L49,48 L55,48 L55,54 L49,54 Z M39,70 L39,59 L45,59 L45,70 L39,70 Z M49,70 L49,59 L55,59 L55,70 L49,70 Z M59,43 L59,37 L65,37 L65,43 L59,43 Z M59,32 L59,26 L65,26 L65,32 L59,32 Z M59,54 L59,48 L65,48 L65,54 L59,54 Z M59,70 L59,59 L65,59 L65,70 L59,70 Z",
    id: "Combined-Shape",
    fill: "#313036"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.ec1ebaf2af12adb7a1d3f2cfb5abdc39.svg";
export { ForwardRef as ReactComponent };